<template>
    <span @click="selected = !selected" class="cursor-pointer d-flex align-items-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16" v-bind:class="{ 'rotated': selected }">
            <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
        </svg>
    </span>
</template>

<script>
export default {
    props:{    
        value: null,
        selectedValue: null
    },
    data () {
        return {
            selected: false
        }
    },
    watch:
    {
        selected: function(val)
        {
            this.$emit('input', val && this.selectedValue ? this.selectedValue : val);
        },
        value: function(val)
        {
            this.selected = this.selectedValue ? val == this.selectedValue : val;
        }
    }
}
</script>

<style scoped>
.rotated {
  transform: rotate(90deg); /* Equal to rotateZ(45deg) */
}
</style>